<div class="spinner-wrapper" *ngIf="shouldShowLoader">

  <mat-spinner></mat-spinner>

</div>